import type { Company } from "kubb";
import type { CompanyType } from "kubb";
import type { User } from "kubb";
import React from "react";
import { userHasTypeForCompany } from "../../model/user";
import { useSelectedCompany } from "../../reducers/company";
import { ProfileContext, useProfile } from "../../reducers/profile";

export default function useUserHasRoles(
  userTypes: string | string[],
  companyType?: CompanyType[],
  ignoreForceViewerMode = false,
): boolean {
  const user = useProfile();
  const company = useSelectedCompany();
  const forceViewerMode =
    React.useContext(ProfileContext).state.forceViewerMode;
  return userHasRole(
    user,
    company,
    userTypes,
    forceViewerMode && !ignoreForceViewerMode,
    companyType,
  );
}

export function userHasRole(
  user: User | undefined,
  company: Company | undefined,
  userTypes: string | string[],
  forceViewerMode = false,
  companyType?: CompanyType[],
): boolean {
  if (user) {
    if (user.user_type === "superadmin") {
      if (forceViewerMode) {
        return userTypes.includes("viewer");
      } else {
        return true;
      }
    } else if (
      company &&
      (!companyType ||
        (company && companyType.includes(company.company_type))) &&
      userHasTypeForCompany(user, company.company_id, userTypes)
    ) {
      return true;
    }
  }
  return false;
}
